import React from 'react';
import { Alert, Link, SpaceBetween, Box } from '@amzn/awsui-components-console';
import { WorkflowInfoPanelConfig } from 'src/@types/common';

interface WorkflowInfoPanelProps {
	config: WorkflowInfoPanelConfig;
}

export const WorkflowInfoPanel: React.FC<WorkflowInfoPanelProps> = ({ config }) => {
	const { type = 'info', header, content, link, dismissible = false } = config;

	return (
		<Box margin={{ bottom: 's' }}>
			<Alert
				type={type}
				header={header}
				dismissible={dismissible}
			>
				<SpaceBetween direction="vertical" size="xs">
					<span>{content}</span>
					{link && (
						<Link
							href={link.href}
							external={link.external ?? link.href.startsWith('http')}
							target="_blank"
						>
							{link.text}
						</Link>
					)}
				</SpaceBetween>
			</Alert>
		</Box>
	);
};
